import { useEffect } from 'react';

export const SITE_URL = 'https://topnotchtechnologies.net';

export const OG_IMAGE =
  'https://readdy.ai/api/search-image?query=Elegant%20abstract%20brand%20banner%20in%20deep%20charcoal%20black%20and%20warm%20golden%20amber%20tones%2C%20soft%20gradient%20light%20rays%20and%20minimal%20geometric%20shapes%20suggesting%20upward%20growth%20and%20personal%20transformation%2C%20premium%20editorial%20style%2C%20generous%20negative%20space%2C%20sophisticated%20modern%20aesthetic%2C%20high%20detail&width=1200&height=630&seq=tnt-coach-og-image&orientation=landscape';

export interface SeoOptions {
  title: string;
  description?: string;
  canonical?: string;
  url?: string;
  image?: string;
  type?: string;
  siteName?: string;
  noindex?: boolean;
}

const upsertMeta = (attr: 'name' | 'property', key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertLink = (rel: string, href: string) => {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export default function useSeo({
  title,
  description,
  canonical,
  url,
  image,
  type = 'website',
  siteName = 'TNT Coach AI',
  noindex = false,
}: SeoOptions) {
  useEffect(() => {
    document.title = title;

    upsertMeta(
      'name',
      'robots',
      noindex
        ? 'noindex, nofollow'
        : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
    );

    if (description) upsertMeta('name', 'description', description);
    if (canonical) upsertLink('canonical', canonical);

    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:site_name', siteName);
    if (description) upsertMeta('property', 'og:description', description);
    if (url) upsertMeta('property', 'og:url', url);
    if (image) upsertMeta('property', 'og:image', image);

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    if (description) upsertMeta('name', 'twitter:description', description);
    if (image) upsertMeta('name', 'twitter:image', image);
    if (url) upsertMeta('name', 'twitter:url', url);
  }, [title, description, canonical, url, image, type, siteName, noindex]);
}